export function initVideoModal() {

	document.addEventListener("DOMContentLoaded", () => {
		const modal = document.getElementById("videoModal");

		if(!modal) return;

		const videoPlayer = modal.querySelector(".video-player");
		const closeButton = modal.querySelector(".modal-close");
		const trapButton = modal.querySelector('.iframe-focus-trap');
		const triggers = document.querySelectorAll(".video-thumbnail-container");

		let previouslyFocusedElement = null;

		function trapFocus(e) {
			if (e.key !== 'Tab') return;

			const focusables = Array.from(
				modal.querySelectorAll(
				'a[href], button:not([disabled]), textarea, input, select, iframe, [tabindex]:not([tabindex="-1"])'
				)
			).filter(el => el.offsetParent !== null);

			const firstEl = focusables[0];
			const lastEl = focusables[focusables.length - 1];

			const active = document.activeElement;

			if (e.shiftKey && active === firstEl) {
				e.preventDefault();
				lastEl.focus();
			} else if (!e.shiftKey && active === lastEl) {
				e.preventDefault();
				firstEl.focus();
			}
		}

		trapButton.addEventListener('click', closeModal);
		trapButton.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				closeModal();
			}
		});


		function openModal(videoId, videoTitle) {
			previouslyFocusedElement = document.activeElement;

			modal.removeAttribute("hidden");
			modal.classList.add("visible");
			document.body.style.overflow = "hidden";

			// Create YouTube iframe
			const iframe = document.createElement("iframe");
			iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
			iframe.width = "560";
			iframe.height = "315";
			iframe.style.border = "0";
			iframe.allow =
				"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
			iframe.allowFullscreen = true;
			iframe.title = `${videoTitle}`;
			iframe.tabIndex = 0;

			videoPlayer.appendChild(iframe);

			// Focus the close button
			closeButton.style.display = 'block';
			trapButton.style.display = 'block';
			requestAnimationFrame(() => closeButton.focus());

			// Enable keyboard trap
			modal.addEventListener("keydown", trapFocus);
		}

		function closeModal() {
			modal.classList.remove("visible");
			modal.setAttribute("hidden", "");
			document.body.style.overflow = "";
			videoPlayer.innerHTML = "";
			closeButton.style.display = 'none';
			trapButton.style.display = 'none';

			// Return focus
			if (previouslyFocusedElement) {
				previouslyFocusedElement.focus();
			}

			modal.removeEventListener("keydown", trapFocus);
		}

		// Open modal on click or keyboard
		triggers.forEach((trigger) => {
			trigger.addEventListener("click", () => {
				const videoId = trigger.getAttribute("data-video-id");
				const videoTitle = trigger.getAttribute("data-video-title");
				if (videoId && videoTitle) openModal(videoId, videoTitle);
			});

			trigger.addEventListener("keydown", (e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					const videoId = trigger.getAttribute("data-video-id");
					const videoTitle = trigger.getAttribute("data-video-title");
					if (videoId && videoTitle) openModal(videoId, videoTitle);
				}
			});
		});

		// Close modal
		closeButton.addEventListener("click", closeModal);
		modal.addEventListener("click", (e) => {
			if (e.target === modal) closeModal(); // click outside content
		});
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape" && modal.classList.contains("visible")) {
				closeModal();
			}
		});
	});
}